import React from 'react';

const Header = () => {
  return (
    <div className='mt-20'>
      <h1 className='text-3xl font-bold text-center'>REST Countries</h1>
    </div>
  );
};

export default Header;
